import React from 'react';
import { Modal } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import Actions from '@/components/buttons/Actions';
import CloseButton from '@/components/buttons/CloseButton';
import { datasourceSupportsTesting } from '../helper';
import DatasourceTestButton, { testDatasourceValidators } from './DatasourceTestButton';

const DatasourceFormActions = ({
  disabled,
  hide,
  isDirty,
  settings,
  testSettings,
  submitForm,
}) => (
  <>
    {(settings.source_exists === true || disabled) && (
      <Modal.Actions>
        <CloseButton messageId="actions.close" onClick={() => hide(settings.category, settings.code)} />
      </Modal.Actions>
    )}
    {(settings.source_exists === false && !disabled) && (
      <Actions
        inProgress={settings.saveStatus === states.PENDING}
        minimumDataEntryMet={isDirty}
        onClose={() => hide(settings.category, settings.code)}
        onSave={submitForm}
        saveMessageId="actions.modify"
      >
        {(testDatasourceValidators[settings.type]) && (
        <div className="float-l">
          <DatasourceTestButton
            connection={settings.connection}
            disabled={!datasourceSupportsTesting(settings, testDatasourceValidators[settings.type])}
            onClick={testSettings}
            testStatus={settings.testStatus}
          />
        </div>
        )}
      </Actions>
    )}
  </>
);

export default DatasourceFormActions;
